
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.5 16a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0-5.004a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM13 7.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"}})])
          )
        }
      }
    